import * as React from 'react';

import Button from '@material-ui/core/Button';
import {
  Field,
  FieldRenderProps,
  Form as FinalForm,
  FormRenderProps,
} from 'react-final-form';

import TextInput from 'components/form/fields/TextInput/TextInput';
import { clientConfig } from 'config/client';

import { IFormDataProps, IInitialValues, IProps } from './interfaces';

import styles from './LoginAuth.module.styl';

export class LoginAuth extends React.Component<IProps> {
  private initialValues: IInitialValues = {
    username:
      typeof clientConfig.mockLogin === 'string' ? clientConfig.mockLogin : '',
  };

  public render() {
    const { onSubmit } = this.props;

    return (
      <FinalForm
        initialValues={this.initialValues}
        onSubmit={onSubmit}
        validate={this.validate}
        render={this.renderedForm}
      />
    );
  }

  private readonly renderedForm = ({
    handleSubmit,
    valid,
    form: { reset },
  }: FormRenderProps<IFormDataProps>) => {
    const { additionalButtons } = this.props;

    const onSubmit = async (event: React.SyntheticEvent<HTMLFormElement>) => {
      const isSuccess = await handleSubmit(event);
      if (isSuccess) {
        reset();
      }
    };

    return (
      <form onSubmit={onSubmit}>
        <Field name="username" render={this.renderedLoginField} />
        <div className={styles.buttons}>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            disabled={!valid}
          >
            Submit
          </Button>
          {additionalButtons}
        </div>
      </form>
    );
  };

  private readonly renderedLoginField = (
    props: FieldRenderProps<string, HTMLInputElement>,
  ) => <TextInput title="Email" {...props} />;

  private readonly validate = (values: IFormDataProps) => {
    const errors: Record<string, string> = {};

    if (!values.username) {
      errors.username = 'Required field!';
    }

    return errors;
  };
}
